export enum ABCLayoutTests {
  A = 'A',
  B = 'B',
  C = 'C'
}
